/**
 * Merlin Father Shopify Theme - JavaScript
 */
(function() {
  'use strict';

  /* ====== COUNTDOWN TIMER ====== */
  function initCountdown() {
    var container = document.querySelector('.countdown-container');
    if (!container) return;

    var endDateStr = container.getAttribute('data-countdown-end');
    if (!endDateStr) return;

    var endDate = new Date(endDateStr).getTime();

    function update() {
      var now = new Date().getTime();
      var diff = endDate - now;
      if (diff <= 0) {
        container.innerHTML = '<span class="countdown-label">SALE ENDED</span>';
        return;
      }
      var h = Math.floor((diff % (1000*60*60*24)) / (1000*60*60));
      var m = Math.floor((diff % (1000*60*60)) / (1000*60));
      var s = Math.floor((diff % (1000*60)) / 1000);

      var hoursEl = container.querySelector('[data-hours]');
      var minsEl = container.querySelector('[data-minutes]');
      var secsEl = container.querySelector('[data-seconds]');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2,'0') + 'H';
      if (minsEl) minsEl.textContent = String(m).padStart(2,'0') + 'M';
      if (secsEl) secsEl.textContent = String(s).padStart(2,'0') + 'S';
    }

    update();
    setInterval(update, 1000);
  }

  /* ====== HERO SLIDER ====== */
  function initHeroSlider() {
    var slides = document.querySelectorAll('.hero-slide');
    var dots = document.querySelectorAll('.hero-dot');
    if (slides.length < 2) return;

    var current = 0;
    var total = slides.length;

    function goTo(index) {
      slides[current].classList.remove('active');
      dots[current].classList.remove('active');
      current = index;
      slides[current].classList.add('active');
      dots[current].classList.add('active');
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var target = parseInt(this.getAttribute('data-slide-target'), 10);
        goTo(target);
      });
    });

    setInterval(function() {
      goTo((current + 1) % total);
    }, 6000);
  }

  /* ====== MOBILE MENU ====== */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var hamburger = toggle.querySelector('.hamburger');
      nav.classList.toggle('open');
      if (hamburger) hamburger.classList.toggle('open');
    });
  }

  /* ====== CART DRAWER ====== */
  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    var toggleBtns = document.querySelectorAll('[data-cart-toggle]');
    var closeBtns = document.querySelectorAll('[data-cart-close]');

    if (!drawer || !overlay) return;

    function openCart() {
      drawer.classList.add('open');
      overlay.classList.add('visible');
      document.body.style.overflow = 'hidden';
    }

    function closeCart() {
      drawer.classList.remove('open');
      overlay.classList.remove('visible');
      document.body.style.overflow = '';
    }

    toggleBtns.forEach(function(btn) {
      btn.addEventListener('click', openCart);
    });

    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeCart();
      });
    });

    overlay.addEventListener('click', closeCart);
  }

  /* ====== QUICK ADD TO CART ====== */
  function initQuickAdd() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-product-id');
      if (!variantId) return;

      btn.textContent = 'ADDING...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        btn.textContent = 'ADDED!';
        updateCartCount();
        setTimeout(function() {
          btn.textContent = 'QUICK ADD';
          btn.disabled = false;
        }, 1500);
        // Reload cart drawer content
        refreshCartDrawer();
      })
      .catch(function() {
        btn.textContent = 'ERROR';
        setTimeout(function() {
          btn.textContent = 'QUICK ADD';
          btn.disabled = false;
        }, 1500);
      });
    });
  }

  /* ====== CART QUANTITY CHANGE ====== */
  function initCartQuantity() {
    document.addEventListener('click', function(e) {
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (!qtyBtn) return;

      var change = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var item = qtyBtn.closest('.cart-item');
      var qtyEl = item ? item.querySelector('.qty-value') : null;
      var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var newQty = Math.max(0, currentQty + change);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        location.reload();
      });
    });

    document.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-remove-item]');
      if (!removeBtn) return;

      var line = parseInt(removeBtn.getAttribute('data-line'), 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        location.reload();
      });
    });
  }

  /* ====== PRODUCT PAGE ====== */
  function initProductPage() {
    // Thumbnails
    var thumbs = document.querySelectorAll('.product-thumb');
    var images = document.querySelectorAll('.product-gallery-image');

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-thumb-index'), 10);
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        images.forEach(function(i) { i.classList.remove('active'); });
        this.classList.add('active');
        if (images[idx]) images[idx].classList.add('active');
      });
    });

    // Quantity buttons
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');
    var qtyInput = document.querySelector('.qty-input');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Variant option selection
    var optionBtns = document.querySelectorAll('.option-value-btn');
    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var position = this.getAttribute('data-option-position');
        var siblings = document.querySelectorAll('.option-value-btn[data-option-position="' + position + '"]');
        siblings.forEach(function(s) { s.classList.remove('selected'); });
        this.classList.add('selected');
      });
    });

    // Product form AJAX
    var form = document.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('.add-to-cart-btn');

        if (submitBtn) {
          submitBtn.textContent = 'ADDING...';
          submitBtn.disabled = true;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          if (submitBtn) {
            submitBtn.textContent = 'ADDED!';
            setTimeout(function() {
              submitBtn.textContent = 'ADD TO CART';
              submitBtn.disabled = false;
            }, 1500);
          }
          updateCartCount();
          // Open cart drawer
          var drawer = document.querySelector('[data-cart-drawer]');
          var overlay = document.querySelector('[data-cart-overlay]');
          if (drawer) drawer.classList.add('open');
          if (overlay) overlay.classList.add('visible');
          document.body.style.overflow = 'hidden';
          refreshCartDrawer();
        })
        .catch(function() {
          if (submitBtn) {
            submitBtn.textContent = 'ERROR';
            setTimeout(function() {
              submitBtn.textContent = 'ADD TO CART';
              submitBtn.disabled = false;
            }, 1500);
          }
        });
      });
    }
  }

  /* ====== GALLERY AUTO SCROLL ====== */
  function initGalleryScroll() {
    var container = document.querySelector('[data-auto-scroll]');
    if (!container) return;

    var speed = 0.5;
    var pos = 0;

    function animate() {
      pos += speed;
      if (pos >= container.scrollWidth / 2) {
        pos = 0;
      }
      container.scrollLeft = pos;
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  }

  /* ====== UPDATE CART COUNT ====== */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var counts = document.querySelectorAll('[data-cart-count], [data-cart-count-drawer]');
        counts.forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
  }

  /* ====== REFRESH CART DRAWER ====== */
  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer-content')
      .then(function() {
        // Simple approach: just reload for now
        // For a more advanced setup, parse the section response
      });
  }

  /* ====== INIT ====== */
  document.addEventListener('DOMContentLoaded', function() {
    initCountdown();
    initHeroSlider();
    initMobileMenu();
    initCartDrawer();
    initQuickAdd();
    initCartQuantity();
    initProductPage();
    initGalleryScroll();
  });

})();
